export const RESET = 'EXSBOWNER_LIST_RESET'
export const SET_ITEMS = 'EXSBOWNER_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBOWNER_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBOWNER_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBOWNER_LIST_TOGGLE_LOADING'
